export const FONT_OPTIONS = [
  {
    label: "Fraunces",
    value: "display",
    family: '"Fraunces", Georgia, serif',
  },
  {
    label: "Georgia",
    value: "serif",
    family: 'Georgia, "Times New Roman", serif',
  },
  {
    label: "Inter",
    value: "sans",
    family: '"Inter", system-ui, sans-serif',
  },
  {
    label: "JetBrains Mono",
    value: "mono",
    family: '"JetBrains Mono", monospace',
  },
];

export function fontFamilyFor(value) {
  return FONT_OPTIONS.find((font) => font.value === value)?.family || FONT_OPTIONS[0].family;
}

export function controlledTypeStyle({ fontSize, font }) {
  return {
    fontSize,
    fontFamily: fontFamilyFor(font),
    fontStretch: "normal",
    fontVariationSettings: "normal",
    letterSpacing: "0",
    transform: "none",
  };
}
